// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyB0bPbT1zlwdXne74V9_Q8N7XcL-mm8oJg",
  authDomain: "index-fund-sahi-hai.firebaseapp.com",
  projectId: "index-fund-sahi-hai",
  storageBucket: "index-fund-sahi-hai.firebasestorage.app",
  messagingSenderId: "624755345286",
  appId: "1:624755345286:web:afe426239bb3452a5a8e07",
  measurementId: "G-6SZKE3KVDF",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// getAnalytics() throws in environments without IndexedDB support (SSR, some
// test runners) — isSupported() guards that so importing this module can
// never break Auth for unrelated consumers.
export let analytics = null;
isSupported()
  .then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  })
  .catch(() => {
    // swallow — analytics must never break the app
  });
